<template>
  <tr>
    <td>
      <div class="d-flex align-items-center">
        <div class="mr-3 star-rating">
          <star-rating
            class="star-rating-vue"
            border-color="#DDD"
            :read-only="pipeline.is_deleted"
            :animate="true"
            active-color="#f05c00"
            :rating="pipeline.employer_rating"
            @rating-selected="setCurrentSelectedRating($event, pipeline.id)"
            :id="pipeline['pipeline_id']"
            :border-width="2"
            :show-rating="false"
            :rounded-corners="true"
            :star-points="starPoints"
            :star-size="20"
          ></star-rating>
          <span class="reset-stars" @click="setCurrentSelectedRating(0, pipeline.id)">
            <i class="fas fa-times-circle"></i>
          </span>
        </div>
      </div>
    </td>
    <td nowrap>
      <router-link
        :to="{
          name: 'manager_candidate_id',
          params: { manager_candidate_id: pipeline.candidate_id },
        }"
        >{{ pipeline.first_name }} {{ pipeline.last_name }}</router-link
      >
    </td>
    <td
      style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
      id="job-pipeline-location"
      nowrap
    >
      {{ pipeline.city.name }},
      {{ pipeline.country.name }}
    </td>
    <td>
      <popper
        v-if="
          typeof pipeline.devskiller_data === 'object' &&
            pipeline.devskiller_data !== null &&
            (pipeline.devskiller_data.status === 'Shared' ||
              pipeline.devskiller_data.status === 'TRANSFERED_SCORE')
        "
        trigger="hover"
        :options="{
          placement: 'top',
          modifiers: { offset: { offset: '0,10px' } },
        }"
      >
        <div class="popper">
          Programming test
        </div>
        <div slot="reference" class="truncate-item">
          {{ `${pipeline.devskiller_data.score}%` }}
        </div>
      </popper>
    </td>
    <td align="center" id="job-pipeline-documents">
      <div class="d-flex">
        <div v-for="doc in pipeline.documents" :key="doc.id">
          <popper
            trigger="hover"
            :options="{
              placement: 'top',
              modifiers: { offset: { offset: '0,10px' } },
            }"
          >
            <div class="popper">{{ doc.name }}</div>
            <a slot="reference">
              <div v-if="getDocumentProperties(doc.name).type === 'pdf'">
                <i
                  @click="
                    openDocPreview(doc.id, doc.name);
                    seenProfile();
                  "
                  :class="[`mr-3 fa`, doc.icon]"
                  :style="
                    `cursor: pointer; color: ${
                      getDocumentProperties(doc.name).color
                    }; font-size: 22px`
                  "
                ></i>
              </div>
              <div v-else>
                <i
                  @click="
                    onDownloadDocument(doc.id, doc.name);
                    seenProfile();
                  "
                  :class="[`mr-3 fa`, doc.icon]"
                  :style="
                    `cursor: pointer; color: ${
                      getDocumentProperties(doc.name).color
                    }; font-size: 22px`
                  "
                ></i>
              </div>
            </a>
          </popper>
        </div>
        <div v-if="pipeline.linkedin">
          <a @click="seenProfile" :href="pipeline.linkedin" target="_blank" rel="nofollow"
            ><i
              style="color: #0077b5 !important; cursor: pointer; font-size: 21px"
              class="fab fa-linkedin"
            ></i
          ></a>
        </div>
      </div>
    </td>
    <td id="job-pipeline-updated" nowrap>
      <popper
        trigger="hover"
        :options="{
          placement: 'top',
          modifiers: { offset: { offset: '-60,10px' } },
        }"
      >
        <div class="popper">
          {{
            pipeline.created_at
              | formatDate({
                format: getManagerUserProfile.format_date,
                timezone: getManagerUserProfile.timezone,
                hasHourAndMinutes: true,
              })
          }}
        </div>
        <div slot="reference">
          {{
            pipeline.created_at
              | formatDate({
                format: getManagerUserProfile.format_date,
                timezone: getManagerUserProfile.timezone,
                hasHourAndMinutes: false,
              })
          }}
        </div>
      </popper>
    </td>
    <td id="stage">
      <div class="d-flex align-items-center">
        <div
          :class="[
            getStageColorClassByTitle(currentStage),
            'stage-size',
            'rounded-circle',
            'mr-2',
            'flex-shrink-0',
          ]"
        ></div>
        <span :class="[currentStage !== 'N/A' ? 'text-nowrap' : 'mr-0', 'stage-text']"
          >{{ currentStage }}
        </span>
      </div>
    </td>
    <td id="actions">
      <div class="icon-wrapper d-flex">
        <button
          @click="setDefaultDocument"
          :data-bs-target="`#editJobPipeline-${pipeline.id}`"
          data-bs-toggle="modal"
          class="btn btn-link"
        >
          <svgHelper class="edit" name="edit" />
        </button>
        <popper
          trigger="hover"
          :options="{
            placement: 'left',
            modifiers: { offset: { offset: '0,10px' } },
          }"
        >
          <div class="popper">
            {{ checkInterviewStatus() }}
          </div>
          <div slot="reference">
            <button
              data-bs-toggle="modal"
              :data-bs-target="
                pipeline.interview.length === 0 ? `#book-${pipeline.id}` : `#confirm-${pipeline.id}`
              "
              type="button"
              class="btn btn-link send-test"
            >
              <svgHelper
                :name="pipeline.interview.length === 0 ? 'interviewInActive' : 'interviewActive'"
              ></svgHelper>
            </button>
          </div>
        </popper>

        <popper
          trigger="hover"
          :options="{
            placement: 'left',
            modifiers: { offset: { offset: '0,10px' } },
          }"
        >
          <div class="popper">
            <span v-if="pipeline.can_initiate_test">Send programming test</span>
            <span v-if="pipeline.devskiller_data && pipeline.devskiller_data.status === 'Shared'"
              >Programming test was completed on
              {{
                pipeline.devskiller_data.completed_date
                  | formatDate({
                    format: getManagerUserProfile.format_date,
                    timezone: getManagerUserProfile.timezone,
                    hasHourAndMinutes: false,
                  })
              }}.</span
            >
            <span v-if="!pipeline.can_initiate_test && pipeline.devskiller_data.status !== 'Shared'"
              >Programming test was sent on
              {{
                pipeline.devskiller_data.created_date
                  | formatDate({
                    format: getManagerUserProfile.format_date,
                    timezone: getManagerUserProfile.timezone,
                    hasHourAndMinutes: false,
                  })
              }}.</span
            >
          </div>

          <div slot="reference">
            <button
              data-bs-toggle="modal"
              :data-bs-target="`#dev-${pipeline.id}`"
              type="button"
              class="btn btn-link send-test"
            >
              <svgHelper
                :style="pipeline.can_initiate_test ? '' : 'fill:#f05a00'"
                name="test"
              ></svgHelper>
            </button>
          </div>
        </popper>
      </div>

      <!-- Edit Modal -->
      <div
        :id="`editJobPipeline-${pipeline.id}`"
        class="modal fade edit-modal"
        tabindex="-1"
        aria-labelledby="editJobPipeline"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="editCandidatePipelineLabel">
                Edit Pipeline - {{ pipeline.first_name }} {{ pipeline.last_name }}
              </h5>
              <button
                ref="closeEditModal"
                type="button"
                @click="clearForm"
                class="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <div class="form-group m-label-left">
                <input
                  type="text"
                  class="form-control mb-3"
                  :value="
                    `${jobad.title}, ${
                      jobad.country ? `${jobad.city.name} ${jobad.country.name}` : ''
                    }`
                  "
                  readonly
                  disabled
                />
                <label for="stage">Position</label>
              </div>

              <div class="form-group m-label-left">
                <input
                  type="text"
                  class="form-control mb-3"
                  readonly
                  disabled
                  :value="`${pipeline.first_name} ${pipeline.last_name}`"
                />
                <label for="stage">Name</label>
              </div>

              <div v-if="pipeline.stage === 107" class="form-group m-label-left">
                <select
                  id="stage"
                  v-model="selectedStage"
                  @change="handleSelectedStage"
                  class="form-control"
                  disabled
                >
                  <option value="not_contacted">Not contacted</option>
                  <option value="contacted">Contacted</option>
                  <option value="interviewing">Interviewing</option>
                  <option value="offered_employment">Offered employment</option>
                  <option value="employed">Employed</option>
                  <option value="no_longer_interested">No longer interested</option>
                  <option value="not_in_consideration">Not in consideration</option>
                </select>
                <label for="stage">Stage</label>
              </div>

              <div v-else class="form-group m-label-left">
                <select
                  id="stage"
                  v-model="selectedStage"
                  @change="handleSelectedStage"
                  class="form-control"
                >
                  <option value="not_contacted">Not contacted</option>
                  <option value="contacted">Contacted</option>
                  <option value="interviewing">Interviewing</option>
                  <option value="offered_employment">Offered employment</option>
                  <option value="employed">Employed</option>
                  <option value="no_longer_interested">No longer interested</option>
                  <option value="not_in_consideration">Not in consideration</option>
                </select>
                <label for="stage">Stage</label>
              </div>

              <div class="form-group m-label-left mb-4">
                <textarea
                  :id="`job-item-comment-textarea-${pipeline.pipeline_id}`"
                  v-model="activity_comment"
                  class="form-control"
                  style="min-height: 3rem"
                  rows="1"
                  placeholder="Аctivity comment"
                  :disabled="isSubmitted === false"
                ></textarea>
                <label for="job-item-comment-textarea">Comment</label>
              </div>

              <!--        <div class="form-group">
                <ul class="list-group file-listing mt-3">
                  <li
                    :key="file.id"
                    v-for="file in pipelineDocuments"
                    class="list-group-item d-flex align-items-center small"
                  >
                    <div class="custom-control custom-checkbox d-flex">
                      <input
                        :id="`edit-pipeline-${file.id}`"
                        class="custom-control-input"
                        type="checkbox"
                        v-model="selectedDocuments"
                        @change="handleCheckboxChange"
                        :value="file"
                        :disabled="isLoading"
                        aria-label
                      />
                      <label class="custom-control-label" :for="`edit-pipeline-${file.id}`">
                        {{ file.name }}
                      </label>
                    </div>

                    <span class="badge badge-primary badge-pill ml-auto">{{
                      `${(file.file_size ? file.file_size / 1024 / 1024 : '').toFixed(2)} MB`
                    }}</span>
                  </li>
                </ul>
              </div> -->
            </div>

            <div class="modal-footer text-center justify-content-center">
              <button @click="onUpdatePipeline" type="button" class="btn btn-primary">
                Save changes
              </button>
              <button
                @click="onCancelUpdatePipeline"
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
            </div>
            <Spinner :isLoading="isPipelineLoading" />
          </div>
        </div>
      </div>
      <!-- End Edit Modal -->

      <TimeBookingModal :pipeline="pipeline" @update="updatePipeline" />
      <ConfirmBookingModal :pipeline="pipeline" @update="updatePipeline" />

      <!-- DevSkiller -->
      <div
        class="modal fade"
        :id="`dev-${pipeline.id}`"
        tabindex="-1"
        aria-labelledby="devModal"
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="devModalLabel">Programming test</h5>
              <button
                ref="closeDevModal"
                type="button"
                class="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="d-flex align-items-center">
                <p v-if="jobad.service_level == 0">
                  We are sorry, but programming tests are not available with the current service
                  level for this job. If you want to upgrade service level, don't hesitate to
                  contact us.
                </p>

                <p v-if="jobad.devskiller_test_id === null">
                  We are sorry, but no test has been assigned to this job yet. Please contact
                  Jobshark if you want us to assign a tailor-made test to this open position.
                </p>

                <p v-if="!pipeline.can_initiate_test">
                  <strong>{{ pipeline.first_name }} {{ pipeline.last_name }}</strong> has already
                  received an invitation for a programming test. The invite was sent on<strong>
                    {{
                      pipeline.devskiller_data.created_date
                        | formatDate({
                          format: getManagerUserProfile.format_date,
                          timezone: getManagerUserProfile.timezone,
                          hasHourAndMinutes: false,
                        })
                    }}</strong
                  >.
                </p>

                <p v-if="pipeline.can_initiate_test && jobad.devskiller_test_id !== null">
                  Please confirm that you want to invite
                  <strong>{{ user.first_name }} {{ user.last_name }}</strong> to conduct the
                  assigned online programming test. You will be notified when the test has been
                  completed. The candidate will have 10 days to complete the test, and you will only
                  be charged if the test is completed <br />
                  <br />
                  In general, we recommend to have an interview with the candidate before inviting
                  him/her to do the programming test.
                </p>
              </div>
            </div>
            <div
              v-if="!pipeline.can_initiate_test || pipeline.has_assign_test === false"
              class="modal-footer text-center justify-content-center"
            >
              <button
                data-bs-dismiss="modal"
                aria-label="Close"
                type="button"
                class="btn btn-primary"
              >
                OK
              </button>
              <!--   <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Contact Jobshark
            </button> -->
            </div>

            <div
              v-if="jobad.service_level == 0"
              class="modal-footer text-center justify-content-center"
            >
              <button
                data-bs-dismiss="modal"
                aria-label="Close"
                type="button"
                class="btn btn-primary"
              >
                OK
              </button>
              <button
                @click="goToContact"
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Contact Jobshark
              </button>
            </div>
            <div
              v-if="pipeline.can_initiate_test && pipeline.devskiller_test_id !== null"
              class="modal-footer text-center justify-content-center"
            >
              <button
                @click="sendTest"
                data-bs-dismiss="modal"
                aria-label="Close"
                type="button"
                class="btn btn-primary"
              >
                Send invite to test
              </button>
              <button
                :disabled="isSending"
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import { stagesMixin } from '../../../mixins/stagesMixin';
import { qualificationMixin } from '../../../mixins/qualificationMixin';
import Spinner from '../../common/LoadingSpinner/Spinner';
import { errorService } from '../../../services/errorService';
import { mapActions, mapGetters } from 'vuex';
import TimeBookingModal from '../common/TimeBookingModal.vue';
import ConfirmBookingModal from '../common/ConfirmBookingModal.vue';
import moment from 'moment';
import axios from 'axios';

export default {
  mixins: [stagesMixin, qualificationMixin],
  props: {
    pipeline: {
      type: Object,
    },
    jobad: {
      type: Object,
    },
    user: {
      type: Object,
    },
  },
  components: {
    Spinner,
    TimeBookingModal,
    ConfirmBookingModal,
  },
  data: () => ({
    isPipelineLoading: false,
    isLoading: false,
    isSending: false,
    rating: {},
    starPoints: [23, 2, 14, 17, 0, 19, 10, 34, 7, 50, 23, 43, 38, 50, 36, 34, 46, 19, 31, 17],
    isSubmitted: false,
    candidateDocumentsFiles: [],
    activity_comment: '',
    selectedStage: '',
    selectedQualification: '',
    currentStage: '',
    currentQualification: '',
    currentUpdatedAt: '',
    selectedDocuments: [],
    pipelineDocuments: [],
    isDisabled: false,
  }),
  methods: {
    ...mapActions('managerStoreModule', [
      'updateManagerDndPipelines',
      'retrieveManagerCandidateDocumentPreview',
    ]),
    ...mapActions([
      'setCandidateManagerPipelineRating',
      'retrieveDocumentPreview',
      'updatePipelineForCandidate',
      'retrieveJobsPipeline',
      'updatePipelineForCandidate',
      'removeCandidateFromPipeline',
      'submitCandidatePipeline',
      'retrieveCandidateDocument',
    ]),

    sendTest() {
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/manager/devskiller/sendinvitation`,
          {
            pipeline_id: this.pipeline.id,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(res => {
          this.$toasted.success(
            `An invite to the programming test has been sent to ${this.pipeline.first_name} ${this.pipeline.last_name}`,
            {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 8000,
            },
          );
          this.$refs.closeDevModal.click();
          this.$emit('pipeline-update', { currentPage: this.getCurrentPage, count: 1000 });
        })
        .catch(err => {
          console.log(err);
        });
    },

    updatePipeline() {
      this.$emit('pipeline-update');
    },

    goToContact() {
      this.$router.push({ name: 'manager-support' });
    },

    checkInterviewStatus() {
      if (this.pipeline.interview.length === 0) {
        return 'Book interview';
      }
      if (this.pipeline.interview.status === 1) {
        return 'Meeting requested';
      }

      if (this.pipeline.interview.status === 2) {
        return 'Confirmed interview';
      }
    },

    onDownloadDocument(docId, docTitle) {
      this.seenProfile();
      this.retrieveManagerCandidateDocumentPreview({ uuid: docId })
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute('download', `${docTitle}`);
          document.body.appendChild(fileLink);

          fileLink.click();
        })
        .catch(err => {
          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },

    seenProfile() {
      axios.post(
        `${process.env.VUE_APP_API_URL}/manager/pipelines/seendate`,
        {
          pipeline_id: this.pipeline.id,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            )}`,
          },
        },
      );
    },
    setSubmitButton() {
      if (this.getQualificationMixin(this.pipeline.qualification).value === 'submitted') {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
    },
    setCurrentPipeline() {
      if (this.currentQualification !== 'Submitted') {
        this.currentQualification = this.getQualificationMixin(this.selectedQualification).title;
      }

      if (this.currentQualification === 'Submitted') {
        this.currentStage = this.getStageMixin(this.selectedStage).title;

        /* Set Modal Values */
        this.selectedStage = this.getStageMixin(this.selectedStage).value;
      }

      this.currentUpdatedAt = this.pipeline.updated_at;
      this.pipelineDocuments = [...this.selectedDocuments];
    },

    setDefaultDocument() {
      this.selectedDocuments = this.pipelineDocuments;
    },
    handleCheckboxChange() {
      console.log(this.selectedDocuments);
    },
    handleSelectedQualification() {
      this.isSubmitted = true;

      if (this.selectedQualification === 'submitted') {
        this.selectedStage = 'not_contacted';
      }
    },
    handleSelectedStage() {
      this.isSubmitted = true;
    },
    openDocPreview(docId, name) {
      const fileExtension = name
        .split('.')
        .pop()
        .toLowerCase();
      const imageFileTypes = ['jpg', 'jpeg', 'png', 'heic'];
      if (imageFileTypes.includes(fileExtension)) {
        this.retrieveManagerCandidateDocumentPreview({ uuid: docId, preview: 'true' })
          .then(response => {
            let mimeType;
            switch (fileExtension) {
              case 'png':
                mimeType = 'image/png';
                break;
              case 'heic':
                mimeType = 'image/heic';
                break;
              default:
                mimeType = 'image/jpeg';
            }

            const blob = new window.Blob([response.data], { type: mimeType });
            const fileURL = window.URL.createObjectURL(blob);

            // Open the image in a new tab
            const newWindow = window.open('', '_blank');
            newWindow.document.write(`
          <html>
            <head>
              <title>Image Preview</title>
            </head>
            <body style="margin:0;">
              <img src="${fileURL}" style="width:100%; height:100%; object-fit:contain;" />
            </body>
          </html>
        `);
            newWindow.document.close();
          })
          .catch(() => {
            this.isCvLoading = false;
          });
      } else {
        this.isCvLoading = true;
        this.retrieveManagerCandidateDocumentPreview({ uuid: docId, preview: 'true' })
          .then(response => {
            this.isCvLoading = false;
            const blob = new window.Blob([response.data], { type: 'application/pdf' });

            const fileURL = window.URL.createObjectURL(blob);

            window.open(fileURL, '_blank').focus();
          })
          .catch(() => {
            this.isCvLoading = false;
          });
      }
    },
    setCurrentSelectedRating(rating, pipelineId) {
      this.pipeline.employer_rating = rating;
      this.setCandidateManagerPipelineRating({ rating, pipeline_id: pipelineId })
        .then(() => {})
        .catch(err => {
          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
    clearForm() {},
    getDocumentProperties(fileName) {
      const re = /(?:\.([^.]+))?$/;

      if (re.exec(fileName)[1] === 'pdf') {
        return {
          color: '#ff0000',
          type: 'pdf',
        };
      } else if (re.exec(fileName)[1] === 'docx' || re.exec(fileName)[1] === 'doc') {
        return {
          color: '#005a9e',
          type: 'doc',
        };
      } else {
        return { color: '#a7a7a77', type: '' };
      }
    },
    onUpdatePipeline() {
      this.isLoading = true;
      this.isPipelineLoading = true;

      this.updateManagerDndPipelines({
        pipeline_id: this.pipeline.id,
        stage: this.selectedStage === 'offered_employment' ? 'offered' : this.selectedStage,
        mr_activity_comment: this.activity_comment,
      })
        .then(() => {
          this.$emit('activity');
          this.isPipelineLoading = false;
          this.isLoading = false;

          this.$toasted.success('Pipeline updated', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });

          this.setCurrentPipeline();

          // Set new date and time
          this.currentUpdatedAt = moment().format();

          // Update activity
          this.$emit('pipeline-update');

          this.$refs.closeEditModal.click();
        })
        .catch(err => {
          this.isLoading = false;
          this.isPipelineLoading = false;
          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
    onSubmitPipeline() {
      this.submitCandidatePipeline({
        pipeline_id: this.pipeline.pipeline_id,
      })
        .then(() => {
          this.isLoading = false;

          this.currentQualification = 'Submitted';
          this.currentStage = 'Not contacted';
          this.currentUpdatedAt = moment().format();
          this.isDisabled = true;

          this.$toasted.show('Pipeline submitted', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });

          // this.$emit('pipeline-reload', { currentPage: 1, count: 10 });
          this.$refs.closeSubmitModal.click();
        })
        .catch(err => {
          this.isLoading = false;

          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
    onDeletePipeline() {
      this.isLoading = true;

      this.removeCandidateFromPipeline({ pipeline_id: this.pipeline.pipeline_id })
        .then(() => {
          this.isLoading = false;

          this.$toasted.show('Pipeline deleted', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });

          this.$emit('pipeline-reload', { currentPage: 1, count: 10 });
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    onCancelUpdatePipeline() {
      this.activity_comment = this.pipeline.activity_comment;
      this.selectedStage = this.getStageMixin(this.pipeline.stage).value;
    },
  },
  computed: {
    ...mapGetters('managerStoreModule', ['getManagerUserProfile']),
  },
  watch: {
    pipeline: {
      handler(newVal, oldVal) {
        // Kick's when user add candidate from AddCandidateBtn
        if (oldVal !== '') {
          this.currentQualification = this.getQualificationMixin(newVal.qualification).title;
          this.currentUpdatedAt = newVal.updated_at;
          this.selectedStage = this.getStageMixin(newVal.stage).value;
        }
        this.pipelineDocuments = [...newVal.documents];
        this.currentStage = this.getStageMixin(this.pipeline.stage).title;
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.setSubmitButton();
    this.setCurrentPipeline();

    this.pipelineDocuments = [...this.pipeline.documents];
    this.selectedStage = this.getStageMixin(this.pipeline.stage).value;
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.icon-wrapper {
  .svg-icon {
    width: 21px;
    height: 21px;
  }
  .edit {
    fill: #a7a7a7;
  }

  .submit {
    fill: #5bb75b;
  }
}

.star-rating {
  position: relative;
  display: block;
  width: 150px;
  display: flex;
  gap: 10px;
  .reset-stars {
    font-size: 16.7px;
    cursor: pointer;
    color: #555;
    display: none;
  }
  &:hover {
    .reset-stars {
      display: block;
    }
  }
}
</style>
